(() => {
  // A shared lock preserves the landing position for both brand and policy dialogs.
  function modalController(dialog) {
    let savedScroll = null;
    let savedBody = null;
    let opener = null;
    const scroller = dialog.querySelector('.tgm-discover-scroll');
    dialog.addEventListener('close', () => {
      dialog.querySelectorAll('video').forEach(video => video.pause());
      if (!savedScroll) return;
      const restore = savedScroll;
      savedBody.forEach(([key, value]) => { document.body.style[key] = value; });
      savedScroll = null;
      window.scrollTo({ left: restore.x, top: restore.y, behavior: 'instant' });
      opener?.focus({ preventScroll: true });
    });
    return {
      open(trigger) {
        if (!dialog.open) {
          opener = trigger;
          savedScroll = { x: window.scrollX, y: window.scrollY };
          savedBody = ['position', 'top', 'left', 'width', 'overflow'].map(key => [key, document.body.style[key]]);
          Object.assign(document.body.style, { position: 'fixed', top: `-${savedScroll.y}px`, left: `-${savedScroll.x}px`, width: '100%', overflow: 'hidden' });
          dialog.showModal();
        }
        scroller.scrollTop = 0;
        dialog.querySelector('[data-close]').focus({ preventScroll: true });
      }
    };
  }

  const discover = document.getElementById('tgm-discover-dialog');
  const discoverOpener = document.querySelector('[data-open-tgm]');
  if (discover && discoverOpener) {
    const controller = modalController(discover);
    const video = discover.querySelector('video');
    discoverOpener.addEventListener('click', () => {
      controller.open(discoverOpener);
      if (video && !video.getAttribute('src')) {
        video.src = video.dataset.tgmVideo;
        video.preload = 'metadata';
        video.load();
      }
    });
    discover.querySelector('[data-tgm-back]').addEventListener('click', () => discover.close());
  }

  const policies = document.getElementById('slowko-policy-dialog');
  const policyController = policies ? modalController(policies) : null;
  const policyPanels = policies ? [...policies.querySelectorAll('[data-policy-panel]')] : [];
  const care = policies?.querySelector('[data-policy-panel="care"]');
  const careSource = document.querySelector('#faq-warranty .faq-answer');
  if (care && careSource) care.append(careSource.cloneNode(true));
  function policyIdentity(href) {
    try {
      const url = new URL(href, location.href);
      if (url.origin !== location.origin) return null;
      if (url.hash === '#faq-warranty' && url.pathname === location.pathname) return 'care';
      return url.pathname.replace(/\/$/, '');
    } catch { return null; }
  }
  const panelByUrl = new Map(policyPanels.map(panel => [policyIdentity(panel.dataset.policyUrl), panel]));
  document.querySelectorAll('a[href]').forEach(link => {
    const panel = panelByUrl.get(policyIdentity(link.getAttribute('href')));
    if (!panel) return;
    link.dataset.policyKey = panel.dataset.policyPanel;
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', 'slowko-policy-dialog');
    link.removeAttribute('target');
  });
  policies?.querySelector('[data-policy-back]').addEventListener('click', () => policies.close());
  // Ordinary links inside a policy keep the landing available in its current tab.
  policies?.querySelectorAll('.slowko-policy-content a[href]').forEach(link => {
    if (!link.dataset.policyKey && /^https?:|^\//i.test(link.getAttribute('href'))) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
  });

  document.addEventListener('click', event => {
    const source = event.target;
    if (!(source instanceof Element)) return;
    const policyLink = source.closest('a[data-policy-key]');
    if (policyLink && policies && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const panel = policyPanels.find(item => item.dataset.policyPanel === policyLink.dataset.policyKey);
      if (panel) {
        event.preventDefault();
        policyPanels.forEach(item => { item.hidden = item !== panel; });
        policies.querySelector('#slowko-policy-title').textContent = panel.dataset.policyTitle;
        policyController.open(policyLink);
        return;
      }
    }
    const link = source.closest('[data-trust-faq]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    const faq = target.closest('.buyer-faq');
    faq?.querySelectorAll('[data-faq-filter]').forEach(filter => filter.setAttribute('aria-pressed', String(filter.dataset.faqFilter === 'all')));
    faq?.querySelectorAll('.faq-item').forEach(item => { item.hidden = false; });
    target.open = true;
    target.querySelector('summary')?.focus({ preventScroll: true });
  });
})();
